import { render, staticRenderFns } from "./PhysicalExam.vue?vue&type=template&id=1942a622&scoped=true&"
import script from "./PhysicalExam.vue?vue&type=script&lang=js&"
export * from "./PhysicalExam.vue?vue&type=script&lang=js&"
import style0 from "./PhysicalExam.vue?vue&type=style&index=0&id=1942a622&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1942a622",
  null
  
)

export default component.exports